export default {
  // @TODO: having a token is not enough to be authenticated, this boolean check below has to be improved
  isAuthenticated: state => () => {
    return (
      Boolean(localStorage.getItem('userToken')) || Boolean(state.userToken)
    )
  },

  authStatus: state => () => state.status,

  configToken: state => () => {
    return localStorage.getItem('configToken') || state.configToken
  },

  userToken: state => () => {
    return localStorage.getItem('userToken') || state.userToken
  },

  userRefreshToken: state => () => {
    return localStorage.getItem('userRefreshToken') || state.userRefreshToken
  },

  userAuthComponents: state => () => ({
    userToken: localStorage.getItem('userToken') || state.userToken,
    userRefreshToken:
      localStorage.getItem('userRefreshToken') || state.userRefreshToken,
  }),
}
